export default __webpack_public_path__ + "static/media/execute_concept_application.7f4e22de.png";